/*
 *
 *  * Copyright(c) 2021 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BannerNotificationComponent } from './banner-notification.component';

@NgModule({
  declarations: [BannerNotificationComponent],
  exports: [BannerNotificationComponent],
  entryComponents: [BannerNotificationComponent],
  imports: [CommonModule, AngularSvgIconModule]
})
export class BannerNotificationModule {}

export { BannerNotificationComponent };
